export class Bridge {
    name: string;
    nc12: string;
    id: number;
    image: string;
    eoc: number;

    isVisible: string;
    isVisibleNa: string;
    isVisibleSa: string;
    isVisibleCn: string;
    isVisibleRoa: string;

    isInMaintenanceMode: string;
    isInMaintenanceModeNa: string;
    isInMaintenanceModeSa: string;
    isInMaintenanceModeCn: string;
    isInMaintenanceModeRoa: string;

    viewStatus: string;
    viewStatusNa: string;
    viewStatusSa: string;
    viewStatusCn: string;
    viewStatusRoa: string;

    description: string;

    datasheetUrl: string;
    cadFiles: string;
    designInGuide: string;
}



// WEBPACK FOOTER //
// ./src/app/_models/bridge.ts